import { Spinner } from '@mi-front/ui';
import { Alert, Box } from '@mui/material';
import AlertTitle from '@mui/material/AlertTitle';
import { Fragment } from '../../../../../types';
import { DownloadMedia } from './DownloadMedia';
import { FragmentCfrTranscoding } from './cfr-transcoding/CfrTranscoding';
import { useIsCfrTranscodingEnabled } from './cfr-transcoding/useIsCfrTranscodingEnabled';

import { useStation } from '@app/core/stations/hooks/useStation';
import { FormattedMessage } from 'react-intl';
interface Props {
  fragment: Fragment;
}

export function MediaStatusInfo(p: Props) {
  const { media } = p.fragment;
  const station = useStation(p.fragment.stationId);
  const isCfrTranscodingEnabled = useIsCfrTranscodingEnabled(station);

  return (
    <div>
      {(media.status === 'WAITING' || media.status === 'IN_PROGRESS') && (
        <Alert severity="info">
          <AlertTitle>
            <FormattedMessage
              id="fragments.mediaStatus.waiting"
              defaultMessage="Generación de media en proceso"
            />
          </AlertTitle>
          <div>
            <Spinner />
          </div>
        </Alert>
      )}

      {media.status === 'ERROR' && (
        <Alert severity="error">
          <AlertTitle>
            <FormattedMessage
              id="fragments.mediaStatus.error"
              defaultMessage="Ocurrió un error durante la generación de media, contacte a soporte."
            />
          </AlertTitle>
        </Alert>
      )}

      {media.status === 'READY' && (
        <Alert severity="success">
          <AlertTitle>
            <FormattedMessage
              id="fragments.mediaStatus.ready"
              defaultMessage="Media de fragmento generada correctamente"
            />
          </AlertTitle>
          <Box mt={2}>
            <DownloadMedia fragment={p.fragment} />
            {isCfrTranscodingEnabled && <FragmentCfrTranscoding fragment={p.fragment} />}
          </Box>
        </Alert>
      )}
    </div>
  );
}
